import React from 'react'
import PropTypes from 'prop-types'
import { FilterGroup } from 'components/common/Filters/FilterGroup'
import Media from 'components/common/Media'

const BrandRefinementMenu = ({ applyFilter, displayName, ...props }) =>
  <Media.Desktop>
    <FilterGroup
      { ...props }
      title={ displayName }
      onChange={ applyFilter } />
  </Media.Desktop>

export default BrandRefinementMenu

BrandRefinementMenu.propTypes = {
  applyFilter: PropTypes.func,
  displayName: PropTypes.string
}
